import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import WelcomeImage from '../../assets/images/welcome/welcome-big-image.png';
import DigtectiveLogoColorful from '../../assets/images/logos/digtective-logo-colorful.svg';
import ShopifyWelcomeForm from './shopifyWelcomeForm';
import useGetOrgByShopifyStore from '../../apiHooks/queries/getOrgByShopifyStore/useGetOrgByShopifyStore';
import LoadingSpinner from '../../components/loadingSpinner/loadingSpinner';

const ShopifyWelcome = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useGetOrgByShopifyStore(searchParams.get('shop') ?? '');

  if (data?.data.data && !isLoading) {
    return (
      <div className="flex h-[100vh] max-h-[1000px] max-w-[1920px] items-center justify-between gap-5 p-5">
        <div className="flex h-full w-[50%] justify-end p-1.5 md:w-[42%]">
          <div className="flex h-full w-full max-w-[408px] flex-col justify-between">
            <div className="h-[20px] max-w-[220px]">
              <img src={DigtectiveLogoColorful} alt="digtective logo" className="mt-4 h-[48px] w-full object-contain" />
            </div>
            <div className="flex w-full items-center justify-center
              rounded-lg border-2 border-green bg-green bg-opacity-10 p-4 text-center text-2xl text-green"
            >
              This store is already connected to an account, please login to your account.
              If you do not have an account please contact support
            </div>
            <p className="text-center text-sm text-primary">
              {t('allRightsReserveDigtective')}
            </p>
          </div>
        </div>
        <div
          className="hidden h-full w-[50%] max-w-[1040px] place-content-center rounded-[38px] bg-[#f5f5f5] p-5 md:grid"
          style={{ background: '#F5F5F5', boxShadow: 'inset 0px 0px 20px 0px #BDBDBDCC' }}
        >
          <div className="h-full max-h-[750px] w-full max-w-[551px] p-5">
            <img src={WelcomeImage} alt="welcome" className="h-full w-full object-contain" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-[100vh] max-h-[1000px] max-w-[1920px] items-center justify-between gap-5 p-5">
      <div className="flex h-full w-[50%] justify-end p-1.5 md:w-[42%]">
        {isLoading ? (
          <div className="flex h-full w-full  flex-col items-center justify-center">
            <LoadingSpinner color="primary" size={100} />
          </div>
        ) : (
          <div className="flex h-full w-full max-w-[408px] flex-col justify-between">
            <div className="h-[20px] max-w-[220px]">
              <img src={DigtectiveLogoColorful} alt="digtective logo" className="mt-4 h-[48px] w-full object-contain" />
            </div>
            { searchParams.get('shop') && searchParams.get('charge_id')
              ? (
                <div className="mt-8 flex w-full flex-col leading-[1.5] text-primary">
                  <h1 className="text-[24px] font-semibold">
                    {t('welcomePageTitle')}
                  </h1>
                  <p className="mt-2 text-sm">
                    {t('welcomePageDescription')}
                  </p>
                  <ShopifyWelcomeForm />
                </div>
              )
              : (
                <div className="flex w-full items-center justify-center
              rounded-lg border-2 border-red bg-red bg-opacity-10 p-4 text-center text-2xl text-red"
                >
                  You are not correlated to a shop, please visit shopify store.
                </div>
              )}
            <p className="text-center text-sm text-primary">
              {t('allRightsReserveDigtective')}
            </p>
          </div>
        ) }

      </div>
      <div
        className="hidden h-full w-[50%] max-w-[1040px] place-content-center rounded-[38px] bg-[#f5f5f5] p-5 md:grid"
        style={{ background: '#F5F5F5', boxShadow: 'inset 0px 0px 20px 0px #BDBDBDCC' }}
      >
        <div className="h-full max-h-[750px] w-full max-w-[551px] p-5">
          <img src={WelcomeImage} alt="welcome" className="h-full w-full object-contain" />
        </div>
      </div>
    </div>
  );
};

export default ShopifyWelcome;
